import { render, staticRenderFns } from "./Rigister.vue?vue&type=template&id=c1c88e14&scoped=true&"
import script from "./Rigister.vue?vue&type=script&lang=js&"
export * from "./Rigister.vue?vue&type=script&lang=js&"
import style0 from "./Rigister.vue?vue&type=style&index=0&id=c1c88e14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c88e14",
  null
  
)

export default component.exports